import mockAxios, { AxiosResponse } from 'axios';
import { IPriceSnapshotServiceMock } from './pricesnapshot.mock.types';

export const mockPriceSnapshotService = (): IPriceSnapshotServiceMock => ({
  fetchPriceSnapshots: jest.fn(),
  fetchPriceSnapshot: jest.fn(),
  createPriceSnapshot: jest.fn(),
  updatePriceSnapshot: jest.fn(),
  deletePriceSnapshot: jest.fn(),
  assignCustomerSnapshot: jest.fn()
});

export const mockPriceSnapshotAxiosResponse = (): AxiosResponse<unknown> => ({
  data: undefined,
  status: 200,
  statusText: 'OK',
  headers: mockAxios.defaults.headers,
  config: mockAxios.defaults
});
